
const styles = {
  container: {
    padding: 16,
    fontFamily: "Inter, Roboto, -apple-system, 'Segoe UI', sans-serif",
    color: "#111",
  },
  heading: {
    marginBottom: 12,
    fontSize: 18,
    fontWeight: 600,
  },
  tableWrapper: {
    overflowX: "auto",
    border: "1px solid #e6e6e6",
    borderRadius: 8,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 980,
  },
  th: {
    textAlign: "left",
    padding: "10px 12px",
    background: "#fafafa",
    borderBottom: "1px solid #eee",
    fontSize: 13,
    color: "#333",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #f2f2f2",
    verticalAlign: "top",
    fontSize: 13,
  },
  filePath: {
    fontFamily: "monospace",
    fontSize: 12,
    color: "#0b3d91",
  },
  summary: {
    maxWidth: 420,
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
  },
  smallMeta: {
    fontSize: 12,
    color: "#666",
  },
  badge: {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 999,
    background: "#eef6ff",
    color: "#054a91",
    fontSize: 12,
    fontWeight: 600,
  },
};

export default function UploadedFilesTable({ data }) {
  return (
    <div style={styles.container}>
      <div style={styles.heading}>Uploaded Files</div>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>File</th>
              <th style={styles.th}>Characters</th>
              <th style={styles.th}>Prompt tokens</th>
              <th style={styles.th}>Completion tokens</th>
              <th style={styles.th}>Total tokens</th>
              <th style={styles.th}>Embedding tokens</th>
              <th style={styles.th}>Uploaded at</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td style={styles.td}>
                  <span style={styles.badge}>{row.id}</span>
                </td>
                <td style={styles.td}>
                  <div style={styles.filePath}>{row.file.split("/").pop()}</div>
                </td>
                <td style={styles.td}>{row.characters.toLocaleString()}</td>
                <td style={styles.td}>{row.prompt_tokens_for_summary}</td>
                <td style={styles.td}>{row.completion_tokens_for_summary}</td>
                <td style={styles.td}>{row.total_tokens_for_summary}</td>
                <td style={styles.td}>{row.tokens_used_for_embedding}</td>
                <td style={styles.td}>
                  <div style={styles.smallMeta}>
                    {new Date(row.uploaded_at).toLocaleString()}
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
